/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import './PanelEdit.scss'

import fileIcon from '../../../assets/svg/fileIcon.svg'

import Menu from '../../../components/InternalMenu/Menu'

import { ToastContainer } from 'react-toastify'
import { useForm } from "react-hook-form"

import { deleteItem, get, post } from '../../../services/http'
import { notify } from '../../../components/Toast'

function index() {
  const [clickButton, setClickButton] = useState(false)
  const [clickButtonDelete, setClickButtonDelete] = useState(false)
  const [pic, setPic] = useState()
  const [files, setFiles] = useState([])
  const [modalPic, setModalPic] = useState('')
  const [picId, setPicId] = useState('')

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)
  
  document.title = 'فایل'

  const { handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let formData = new FormData()

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } 
    formData.append('pic', pic)

    post(`/api/admin/files?token=${token}`, formData, config).then(response => {
        if (response.data.status) {
          notify('success', 'فایل با موفقیت آپلود شد')
          get(`/api/admin/files?token=${token}`).then(response => {
            setFiles(response.data.data)
            setClickButton(false)
          })
        }
      }).catch(error => {
        setClickButton(false)
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  useEffect(() => {
    get(`/api/admin/files?token=${token}`).then(response => {
      setFiles(response.data.data)
    })
  }, [token])

  const picHandler = (e) => {
    setModalPic(e.target.currentSrc)
    setModal(true)
    setCover(true)
    setPicId(e.target.id)
  }

  const deleteHandler = (e) => {
    setClickButtonDelete(true)
    deleteItem(`/api/admin/files/${picId}?token=${token}`).then(response => {
      if (response.status) {
        notify('success', 'فایل با موفقیت حذف شد')
        get(`/api/admin/files?token=${token}`).then(response => {
          setFiles(response.data.data)
          setClickButton(false)
        })
        setModal(false)
        setCover(false)
        setClickButtonDelete(false)
      }
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='pictureModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید عکس مورد نظر حذف شود؟
        </div>
        <hr />
        <img src={modalPic} style={{ maxWidth: '400px' }} />
        <input type='text' defaultValue={modalPic} />
        <div className="buttons">
          <button onClick={deleteHandler} style={clickButtonDelete ? { backgroundColor: 'gray' } : {}} disabled={clickButtonDelete ? true : false}>{clickButtonDelete ? 'در حال حذف ...' : 'حذف فایل'}</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <Menu page={'files'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='icon'>
                <img src={fileIcon} alt='fileIcon' width={'19px'} />
              </div>
              <div className='text'>
                لیست فایل‌ها
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای آپلود فایل جدید فایل مورد نظر را انتخاب کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              آپلود فایل 
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantDetails'>فایل * :</label>
                <input id='resturantDetails' 
                  onChange={e => {
                  const fileSelect = e.target.files[0]
                    setPic(fileSelect)
                  }} type='file' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپلود فایل'}</button>
            <div className='lineTitle'>
              <hr />
              لیست فایل‌ها 
              <hr />
            </div>
            <div className='row'>
              <div className='columnPicture'>
                {files ? files.map((item, index) => (
                  <img onClick={picHandler} id={item} key={index} src={`https://cannoli.storage.iran.liara.space/${item}`} />
                )) : 'loading...'}
              </div>
            </div>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index